<template>
<!-- 去专柜 -->
<div class="padding20 bg-white borderb" v-if="data">
	<a :href="data.clickUrl" :data-scp="$options.name+'.00'" data-bk="find-{{pageId}}">
		<div class="flex-container padding10" style="background-color:#f8f8f8;">
			<div class="img-container" style="width:40px;height:40px;">
				<img :src="data.logoImageUrl" alt="" style="width:100%;height:100%">
			</div>
			<div class="marginl20 paddingr20 fs-12 flex1">
				<p class="text-dark" v-text="data.title"></p>
				<p class="text-light fs-10" v-text="data.address"></p>
			</div>		
			<div class="btn red radius small marginr10" style="border-radius:500px;border-color: #e0e0e0;padding: 1px 17px;font-size:12px;line-height: 22px;border:0;">去专柜</div>		
		</div>
	</a>
</div>
</template>
<script>
export default{
	props: {
		data: {
			type: Object
			, default: null
		}
	},
	data:function(){
		return {
			pageId:maple.url().params.id
		}
	}
}
</script>